import { memo } from "react";

import "./ExportSummary.scss";
import ExportPageComponent from "../../page/dashboard/home/export-components/ExportPageComponent";
import ExportPageHeader from "../../page/dashboard/home/export-components/header/ExportPageHeader";
import {
  GenericGraphDataEntry,
  OverallRecycledWasteEntry,
} from "../../service/utils/interfaces";

interface ExportSummaryProps {
  startDate: Date | null;
  endDate: Date | null;
  selectedSites?: any;
  selectedWasteTypes?: any;
  selectedCustomer?: any;
  achievementDataArray: any[];
  printRecycledWasteTypes: GenericGraphDataEntry[];
  printRecycledWasteDetails: any[][];
  WTByPeriodGraph: any[];
  WTByPeriodTable: any[];
  WTByPeriodLegend: any[];
  WTBySiteGraph: any[];
  WTBySiteTable: any[];
  WTBySiteLegend: any[];
  overallRecycledWastes: OverallRecycledWasteEntry[];
  overallRecycledWastesExportTable: any[];
  overallRecycledWastesColors: any[];
  emissionsGeneratedDetails: GenericGraphDataEntry[];
  LBRecyclingRateTopGraph: any[];
  LBRecyclingRateTopTable: any[];
  LBEmissionRateBottomGraph: any[];
  LBEmissionRateBottomTable: any[];
  LBReducedWasteRateTopGraph: any[];
  LBReducedWasteRateTopTable: any[];
}

const ExportSummary = memo((props: ExportSummaryProps) => {
  return (
    <>
      <div className="printable-summary-view">
        <ExportPageComponent
          filterDateStart={props.startDate ?? new Date()}
          filterDateEnd={props.endDate ?? new Date()}
          filterSiteList={props.selectedSites}
          filterWasteTypeList={props.selectedWasteTypes}
          achievementDataArray={props.achievementDataArray}
          recycledWasteTypes={props.printRecycledWasteTypes}
          recycledWasteDetails={props.printRecycledWasteDetails}
          wasteTypePeriodGraphData={props.WTByPeriodGraph}
          wasteTypePeriodTableData={props.WTByPeriodTable}
          wasteTypePeriodLegendData={props.WTByPeriodLegend}
          wasteTypeSiteGraphData={props.WTBySiteGraph}
          wasteTypeSiteTableData={props.WTBySiteTable}
          wasteTypeSiteLegendData={props.WTBySiteLegend}
          recycledRecoveredGraphData={props.overallRecycledWastes}
          recycledRecoveredTableData={props.overallRecycledWastesExportTable}
          recycledRecoveredLegendData={props.overallRecycledWastesColors}
          co2EmissionsGenerated={props.emissionsGeneratedDetails}
          leaderboardRRTopGraph={props.LBRecyclingRateTopGraph}
          leaderboardRRTopTable={props.LBRecyclingRateTopTable}
          leaderboardERTopGraph={props.LBEmissionRateBottomGraph}
          leaderboardERTopTable={props.LBEmissionRateBottomTable}
          leaderboardRWRTopGraph={props.LBReducedWasteRateTopGraph}
          leaderboardRWRTopTable={props.LBReducedWasteRateTopTable}
        />
      </div>
      <div id="export-header" className="printable-summary-view">
        <ExportPageHeader
          customerName={
            props.selectedCustomer ? props.selectedCustomer.label : ""
          }
        />
      </div>
    </>
  );
});

export default ExportSummary;
